function ageGate() {

    $('.js-submit-age-gate').on('submit', (e) => {
        e.preventDefault();

        const legalAge = parseInt($('#legal_age').val());
        const inputBirthYear = parseInt($('#birth_year').val()) ? parseInt($('#birth_year').val()) : 0;
        const currentYear = new Date().getFullYear();
        const errorMessage = $('.age-gate__error');
        const ageGate = $('.age-gate');
        const rememberMeCheckbox = $('#remember_me');

        errorMessage.fadeOut();

        if (currentYear - inputBirthYear < legalAge || inputBirthYear < 1900) {
            errorMessage.fadeIn();
        } else {
            ageGate.addClass('fade-out');
            $('html').removeClass('age-block');
            if (rememberMeCheckbox.prop('checked')) {
                setAgeGateCookie();
            } 
        }
        
    })

    const setAgeGateCookie = () => {
        let date = new Date();
        date.setTime(date.getTime() + (365*24*60*60*1000));
        const expires = "expires="+date.toUTCString();

        document.cookie = 'STYXKEY_ageGate' + "=" + 'checked' + "; " + expires;
    }

}

export default ageGate